import { createContext } from "react";

export type ThemeType = "dark" | "light" | "system";

type ThemeProviderStateType = {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
};

const initialState: ThemeProviderStateType = {
  theme: "system",
  setTheme: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderStateType>(initialState);
